export enum QuotationType {
  Travel = 'travel',
  Vehicle = 'vehicle',
}
